import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const HeroLeadForm = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const isZh = i18n.language === 'zh';
  const [form, setForm] = useState({ first_name: '', last_name: '', phone: '', email: '' });
  const [agreed, setAgreed] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async () => {
    if (!form.first_name || !form.phone || !form.email) {
      toast.error(isZh ? '请填写必填项' : 'Please fill in required fields');
      return;
    }
    if (!agreed) {
      toast.error(isZh ? '请勾选隐私声明' : 'Please agree to the privacy statement');
      return;
    }
    setSubmitting(true);
    try {
      const r = await axios.post(`${API}/admin/quick-register`, form);
      if (r.data.token) {
        localStorage.setItem('admin_token', r.data.token);
        localStorage.setItem('admin_role', r.data.role);
        localStorage.setItem('admin_email', r.data.email || r.data.phone);
      }
      navigate('/thank-you');
    } catch {
      toast.error(isZh ? '提交失败' : 'Submit failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bg-black/50 backdrop-blur-md rounded-2xl p-4 sm:p-6 w-full max-w-xs" data-testid="hero-lead-form">
      <p className="text-white text-xs sm:text-sm font-semibold text-center mb-4 sm:mb-5">
        {isZh ? '填写下方表单，我们将为您提供免费咨询。' : 'Complete the form below and we will contact you for a Free Consultation.'}
      </p>
      <div className="space-y-2 sm:space-y-3">
        <input value={form.first_name} onChange={e => set('first_name', e.target.value)}
          placeholder={isZh ? '名 *' : 'First Name*'}
          className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white rounded-lg text-sm text-gray-900 placeholder-gray-400 outline-none" />
        <input value={form.last_name} onChange={e => set('last_name', e.target.value)}
          placeholder={isZh ? '姓 *' : 'Last Name*'}
          className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white rounded-lg text-sm text-gray-900 placeholder-gray-400 outline-none" />
        <div className="flex bg-white rounded-lg overflow-hidden">
          <div className="flex items-center gap-1 px-2 sm:px-3 border-r border-gray-200 flex-shrink-0">
            <span className="text-sm">🇺🇸</span>
            <span className="text-xs text-gray-500">+1</span>
          </div>
          <input value={form.phone} onChange={e => set('phone', e.target.value)}
            placeholder={isZh ? '电话 *' : 'Phone*'} type="tel"
            className="flex-1 px-2 sm:px-3 py-2.5 sm:py-3 text-sm text-gray-900 placeholder-gray-400 outline-none" />
        </div>
        <input value={form.email} onChange={e => set('email', e.target.value)}
          placeholder={isZh ? '邮箱 *' : 'Email Address*'} type="email"
          className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white rounded-lg text-sm text-gray-900 placeholder-gray-400 outline-none" />
      </div>
      <label className="flex items-start gap-2 cursor-pointer mt-2 sm:mt-3">
        <input type="checkbox" checked={agreed} onChange={e => setAgreed(e.target.checked)} className="mt-0.5 accent-orange-500 flex-shrink-0" />
        <span className="text-[10px] text-white/70 leading-relaxed">
          {isZh
            ? '为完成账号登录与身份核验，系统将读取您的公开基础信息。您的个人信息将受到严格保护，仅在本次授权范围内使用。'
            : 'For login and account security, we will access your public profile (nickname, avatar). Your information is protected and will only be used for identity verification.'}
        </span>
      </label>
      <Button onClick={handleSubmit} disabled={submitting}
        className="w-full mt-3 sm:mt-4 bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 sm:py-3.5 text-sm sm:text-base rounded-lg transition-all"
        data-testid="hero-lead-submit">
        {submitting ? '...' : (isZh ? '提交 »' : 'Submit »')}
      </Button>
    </div>
  );
};

export default HeroLeadForm;
